import FormattedDateTime from 'I18n/components/FormattedDateTime';
import I18n from 'I18n';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import { TimeZoneStrategyType } from 'automation-ui-flow-core/fields/time/TimeZoneStrategy';
import FormattedTimeDelay from 'automation-ui-action-features/components/delay/FormattedTimeDelay';
import { jsx as _jsx } from "react/jsx-runtime";
function getFormattedTimeOfDay(metadata) {
  var _metadata$getTimeZone;
  const timeOfDay = metadata.getTimeOfDay();
  const isUsingObjectTimezone = metadata.getTimeZoneStrategy() && ((_metadata$getTimeZone = metadata.getTimeZoneStrategy()) === null || _metadata$getTimeZone === void 0 ? void 0 : _metadata$getTimeZone.type) === TimeZoneStrategyType.ENROLLED_OBJECT;
  return timeOfDay ? /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedDateTime
    // @ts-expect-error the added types for portalTz are missing an override for MomentInput as a parameter
    , {
      value: I18n.moment.portalTz({
        hour: timeOfDay.hour,
        minute: timeOfDay.minute
      })
      /* includes `(Z)` format to disambiguate between timezones with the same abbreviation by showing the UTC offset */,
      format: isUsingObjectTimezone ? 'LT' : 'LT z (Z)'
    })
  }) : /*#__PURE__*/_jsx(MissingLabel, {
    type: "timeOfDay"
  });
}
export function getPropertyDateDelayFormatOptions(metadata, flowObjectTypeId) {
  const date = metadata.getDate();
  const delta = metadata.getTimeDelta();
  const count = Math.abs(delta.getDelta());
  return {
    timeOfDay: getFormattedTimeOfDay(metadata),
    datePropertyName: /*#__PURE__*/_jsx(PropertyName, {
      propertyName: date.getPropertyName(),
      objectTypeId: flowObjectTypeId
    }),
    count,
    numberOfDays: /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedTimeDelay, {
        timeDelay: delta
      })
    })
  };
}
export function getStaticDateDelayFormatOptions(metadata) {
  const date = metadata.getDate();
  const dateValue = date.getValue();
  return {
    timeOfDay: getFormattedTimeOfDay(metadata),
    formattedDate: dateValue !== null ? /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: Number(dateValue),
        format: "LL",
        type: "utc"
      })
    }) : /*#__PURE__*/_jsx(MissingLabel, {
      type: "date"
    })
  };
}